<script lang="ts" setup>
const { isDesktop, isMobileOrTablet } = useDevice()

defineProps({
  markingComposition: {
    type: String,
    required: true,
  },
})

const tooltipCompound = ref(false)
</script>

<template>
  <div class="compound">
    <app-tooltip
      v-model="tooltipCompound"
      :right="isDesktop"
      :bottom="isMobileOrTablet"
    >
      <template #activator>
        <span
          class="button"
          @mouseover="tooltipCompound = true"
          @mouseleave="tooltipCompound = false"
          @click="
            tooltipCompound
              ? (tooltipCompound = false)
              : (tooltipCompound = true)
          "
        >
          Состав
        </span>
      </template>

      <template #content>
        <div class="compound__text">
          <span class="compound__text-title">Состав</span>
          <span class="compound__text-content">{{ markingComposition }}</span>
        </div>
      </template>
    </app-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.compound {
  width: max-content;
  font-size: 16px;
  font-weight: 600;
  color: $primary;

  &__text {
    &-title {
      display: block;
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: 800;
      line-height: 19px;
      letter-spacing: 0;
    }

    &-content {
      display: inline-block;
      font-size: 14px;
      font-weight: 600;
      line-height: 26px;
      letter-spacing: 0;
    }
  }
}
</style>
